module.exports = __webpack_public_path__ + "product/create-input-size-request-c4fdf49865781bed1d85e619acb06643.png";